import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { isoToLocalDate, localDateToIso } from "../utils/dateFormat";

export default function IsoDatePicker({
  value,
  onChange,
  min,
  max,
  className = "form-control",
  placeholderText = "DD/MM/YYYY",
  ...props
}) {
  return (
    <DatePicker
      {...props}
      selected={isoToLocalDate(value)}
      onChange={(date) => onChange(localDateToIso(date))}
      minDate={isoToLocalDate(min)}
      maxDate={isoToLocalDate(max)}
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholderText}
      className={className}
      wrapperClassName="w-100"
    />
  );
}
